import { render } from "./ProgressBarNoBgItem.vue?vue&type=template&id=ef6b25b0&scoped=true"
import script from "./ProgressBarNoBgItem.vue?vue&type=script&lang=js"
export * from "./ProgressBarNoBgItem.vue?vue&type=script&lang=js"

import "./ProgressBarNoBgItem.vue?vue&type=style&index=0&id=ef6b25b0&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6b25b0"]])

export default __exports__